import numeral from 'numeral';
import dayjs from 'dayjs';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

// export function fCurrency(number) {
//   const format = number ? numeral(number).format('$0,0.00') : '';

//   return result(format, '.00');
// }

export function fCurrency(number) {
  const format = number ? `₹ ${numeral(number).format('0,0.00')}` : '₹ 0';
  
  return result(format, '.00');
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

export function fDate(date, format = 'DD/MM/YYYY') {
  if (!date) return '';
  return dayjs(date).format(format);
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function fDataMB(number) {
  const format = number ? numeral(number).format('0.0 b')  : '';
  
  return result(format, ' .0');
}